// Container da listagem: liga o hook (URL, dados, mutations) aos componentes.
import { AppPagination } from "@/components/commons/app-pagination"
import { FRONTEND_ROUTES } from "@/constants"

import {
  paymentConfigurationDetailHref,
  usePaymentConfigurationsList,
} from "../use-payment-configurations-list"
import { DeactivatePaymentConfigurationDialog } from "./deactivate-payment-configuration-dialog"
import { PaymentConfigurationsFilters } from "./payment-configurations-filters"
import { PaymentConfigurationsList } from "./payment-configurations-list"

export const PaymentConfigurationsPanel = () => {
  const list = usePaymentConfigurationsList()

  return (
    <div className="flex flex-col gap-4">
      <PaymentConfigurationsFilters
        status={list.status}
        hasActiveFilters={list.hasActiveFilters}
        onStatusChange={list.handleStatusChange}
        onClear={list.clearFilters}
      />
      <PaymentConfigurationsList
        items={list.items}
        isLoading={list.isLoading}
        isError={list.isError}
        errorVariant={list.errorVariant}
        isStale={list.isStale}
        hasActiveFilters={list.hasActiveFilters}
        canWrite={list.canWrite}
        createHref={
          FRONTEND_ROUTES.PAYMENT_CONFIGURATIONS_CREATE.href
        }
        togglingId={list.togglingId}
        whiteLabelNameOf={list.whiteLabelNameOf}
        detailHrefOf={paymentConfigurationDetailHref}
        onRetry={() => void list.refetch()}
        onClearFilters={list.clearFilters}
        onActivate={list.handleActivate}
        onDeactivate={list.handleDeactivate}
      />
      {/* Pela contagem total, não pelos itens da página: em `?page=99` além do
          fim a página vem vazia, e sem paginação não haveria como voltar. */}
      {list.pagination &&
        !list.isError &&
        list.pagination.total > 0 && (
          <AppPagination pagination={list.pagination} />
        )}
      <DeactivatePaymentConfigurationDialog
        pending={list.pendingDeactivate}
        onConfirm={list.confirmDeactivate}
        onClose={list.closeDeactivate}
      />
    </div>
  )
}
